import { account } from './account'
import { classroom } from './classroom'
import { readingExercise } from './reading-exercise'
import { readingQuestion } from './reading-question'

export const Api = {
  account,
  classroom,
  readingExercise,
  readingQuestion
}
